package com.appsyde.shared.presentation.screen.screen

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.appsyde.shared.presentation.style.AppStylesLoading
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.Style
import org.jetbrains.compose.web.dom.*

@Composable
fun LoadingScreen() {
    Style(AppStylesLoading)

    val loadingPhases = remember {
        listOf(
            "Connexion sécurisée",
            "Initialisation de votre espace",
            "Récupération des tickets",
            "Chargement des dernières interactions",
            "Analyse du contexte client",
            "Extraction des données clés",
            "Structuration des informations",
            "Préparation des suggestions IA",
            "Synchronisation des statuts",
            "Vérification de cohérence",
            "Optimisation de l’affichage",
            "Finalisation de la session",
            "Ouverture de votre tableau de bord"
        )
    }

    var phaseIndex by remember { mutableStateOf(0) }
    var phaseVisible by remember { mutableStateOf(true) }

    LaunchedEffect(loadingPhases) {
        while (true) {
            // Délai aléatoire entre 1 et 4 s pour chaque phase → impression de tâches de longueurs différentes
            delay((1000..4000).random().toLong())
            phaseVisible = false
            delay(260)
            phaseIndex = (phaseIndex + 1) % loadingPhases.size
            phaseVisible = true
        }
    }

    Div({ classes(AppStylesLoading.page) }) {

        // top bar
        Div({ classes(AppStylesLoading.topBar) }) {
            Div({ classes(AppStylesLoading.brand) }) {
                Img("/appsydeIcon.png", attrs = {
                    classes(AppStylesLoading.brandIcon)
                    attr("alt", "AppSyde")
                })
                Span { Text("AppSyde") }
            }
        }

        // center
        Div({ classes(AppStylesLoading.centerWrap) }) {

            // aurora background (soft like landing)
            Div({ classes(AppStylesLoading.aurora) }) {
                Div({ classes(AppStylesLoading.blob1) })
                Div({ classes(AppStylesLoading.blob2) })
            }

            Div({ classes(AppStylesLoading.card) }) {

                H1({
                    classes(
                        AppStylesLoading.phaseHeadline,
                        if (phaseVisible) AppStylesLoading.phaseVisible else AppStylesLoading.phaseHidden
                    )
                    attr("aria-live", "polite")
                }) {
                    Text(loadingPhases[phaseIndex])
                }

                P({ classes(AppStylesLoading.subtitle) }) {
                    Text("Préparation de votre espace de support")
                }

                Div({ classes(AppStylesLoading.progressTrack) }) {
                    Div({ classes(AppStylesLoading.progressIndicator) })
                }
            }

            Footer({ classes(AppStylesLoading.footer) }) {
                Text("© 2026 AppSyde")
            }
        }
    }
}
